<template>
  <div class="orderContent clearfix">
    <div class="jiazaiBox" v-if="info===null">
      <div class="spinner-border text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-if="info!==null" class="zhifuBox mb-3">
      <!--未跳转，未支付成功，未关闭-->
      <div v-if="!isJumpSuccess && info.is_state*1 !== 1 && info.is_state*1 !== 2 && info.is_state*1 !== 3">
        <div class="fangshiBox mb-3">
          <span @click="checkPatType(1)" class="cursor" :class="{active:pay===1}">
            <img src="/static/images/aliPay.svg">
            支付宝支付
          </span>
            <span @click="checkPatType(2)" class="cursor" :class="{active:pay===2}">
            <img src="/static/images/wechatPay.svg">
            微信支付
          </span>
        </div>
        <div v-if="pay===1" class="zhifubaoBox">
          <h2 class="text-danger">{{info.currencyType==='1'?'￥':''}}{{info.currencyType==='2'?'$':''}}{{info.price}}</h2>
          <span @click="payZhifubaoFun" class="text-primary cursor">支付宝：前往支付宝收银台支付 <i class="iconfont icon-qianwang text-primary cursor"></i></span>
        </div>
        <div v-if="pay===2" class="weixinBox">
          <div class="leftBox">
            <h2 class="text-danger">{{info.currencyType==='1'?'￥':''}}{{info.currencyType==='2'?'$':''}}{{info.price}}</h2>
            <div v-if="makeWechatpayLoading">
              付款码生成中...
            </div>
            <div v-if="!makeWechatpayLoading" class="content">— 微信支付，扫一扫</div>
          </div>
          <div class="rightBox">
            <img v-if="!makeWechatpayLoading" class="zhifuImg img-thumbnail" :src="base64">
            <div v-if="makeWechatpayLoading" class="spinner-border text-primary mb-3" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      </div>
      <div class="paySuccessBox" v-if="isJumpSuccess && info.is_state*1 === 0">
        <i class='iconfont icon-jiazai xuanzhuan text-primary'></i>
        <div class="text-primary">支付中，检测支付结果中</div>
      </div>
      <div class="paySuccessBox" v-if="info.is_state*1 === 1 || info.is_state*1 === 2">
        <i class="iconfont icon-chenggong text-success"></i>
        <div class="text-success">支付成功，前往【<router-link tag='span' class="cursor" to="/home/order">我的订单</router-link>】</div>
      </div>
      <div class="paySuccessBox" v-if="info.is_state*1 === 3">
        <i class="iconfont icon-jinggao text-danger"></i>
        <div class="text-danger">订单已关闭，支付链接关闭</div>
      </div>
    </div>
    <div v-if="info!==null" class="searchBox titleBox mb-3">
      <div class="box">
        <h5>
          订单编号：{{info.no}}
          <span class="badge badge-danger float-right" v-if="info.is_state * 1 === 0">待付款</span>
          <span class="badge badge-success float-right" v-if="info.is_state * 1 === 1">已付款</span>
          <span class="badge badge-success float-right" v-if="info.is_state * 1 === 2">已付款</span>
          <span class="badge badge-dark float-right" v-if="info.is_state * 1 === 3">已取消</span>
        </h5>
        <hr style="border-color:rgba(0,0,0,0.1);">
        <div class="goodsBox row">
          <div class="col-12 col-md-6">
            <span>
              <i class="description">订单金额：</i>{{info.currencyType==='1'?'￥':''}}{{info.currencyType==='2'?'$':''}}{{info.price}}
            </span>
          </div>
          <div class="col-12 col-md-6">
            <span><i class="description">创建时间：</i> {{info.addtime}}</span>
          </div>
        </div>
      </div>
    </div>
<!--    {{info}}-->
    <div v-if="info!==null" class="threeBox yuanjiao mb-3">
      <h5>订单内容</h5>
      <p class="content"><small>— 包含订单内所有的商品列表</small></p>
      <div class="table-responsive table-bordered">
        <table class="table">
          <tbody>
          <tr v-for="(app,index) in info.check" :key="index">
            <td>
              <span class="content" v-if="app.is_state*1===2">赠送 / </span>{{app.name}} × {{app.num}}
            </td>
            <td v-if="app.is_state*1===1" class="text-right">
              {{info.currencyType==='1'?'￥':''}}{{info.currencyType==='2'?'$':''}}{{app.totalPrice}}
            </td>
            <td v-else class="text-right content">
              赠送
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="info!==null && info.mailInfo!==null" class="threeBox yuanjiao mb-3">
      <h5 class="mt-0">收件地址</h5>
      <p class="content"><small>— 设备与软件的收货方式</small></p>
      <hr class="mb-4" style="border-color:rgba(0,0,0,0.1);">
      <div class="table-responsive-sm">
        <dl class="row">
          <dt v-if="info.mailInfo && info.mailInfo.mailName && info.mailInfo.mailPhone && info.mailInfo.mailAddress" class="col-sm-3 content">设备收件</dt>
          <dd v-if="info.mailInfo && info.mailInfo.mailName && info.mailInfo.mailPhone && info.mailInfo.mailAddress" class="col-sm-9">
            <p><span class="content">收&nbsp;&nbsp;件&nbsp;&nbsp;人：</span>{{info.mailInfo?info.mailInfo.mailName:'...'}}</p>
            <p><span class="content">收件电话：</span>{{info.mailInfo?info.mailInfo.mailPhone:'...'}}</p>
            <p><span class="content">收件地址：</span>{{info.mailInfo?info.mailInfo.mailAddress:'...'}}</p>
            <hr>
          </dd>
          <dt class="col-sm-3 content">软件收货</dt>
          <dd class="col-sm-9">
            订单详情在线发放激活码
          </dd>
        </dl>
      </div>
    </div>
    <div v-if="info!==null && info.moneyLog.huodongArr!==null" class="threeBox yuanjiao mb-3">
      <h5 class="mt-0">活动记录</h5>
      <p class="content"><small>— 参与的活动都在这里</small></p>
      <div class="table-responsive-sm table-bordered">
        <table class="table">
          <tbody>
          <tr v-for="(app,index) in info.moneyLog.huodongArr" :key="index">
            <td>{{app.title}}</td>
            <td class="text-right">{{info.currencyType==='1'?'￥':''}}{{info.currencyType==='2'?'$':''}}{{app.price}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import { EventBus } from '@/util/eventBus';
  import resultcommons from '@/util/resultcommons';
  import generalMix from '@/util/mix/general';

  export default {
    name: 'orderContent',
    props:['parameter'],
    mixins: [generalMix],
    data () {
      return {
        isLoading:true,
        info:null,
        id: 0,
        // 支付方式
        pay:1,
        // 支付根地址
        paymentBaseUrl: process.env.PAYMENT_BASE_URL,
        // 微信二维码生成状态
        makeWechatpayLoading:false,
        base64:'',
        // 跳转成功
        isJumpSuccess:false
      }
    },
    methods:{
      closeViewPayBox(){
        this.isViewPaybox = false;
        clearInterval(Window.timerUploadOrder);
      },
      // 更新订单支付状态
      timerUploadOrder() {
        // 支付成功
        resultcommons.apiOrdercatalogstate(this,{no:this.info.no}).then(app=>{
          if(app.state === 200){
            if(app.data.state !== '0'){
              clearInterval(Window.timerUploadOrder);
            }else{
              if(this.finallyPrice * 1 !== app.data.price * 1){
                this.finallyPrice = app.data.price;
                if(this.pay === 2){
                  this.checkPatType(2);
                }
              }
            }
            // 更新状态
            this.info.is_state = app.data.state;
          }
        });
      },
      // 切换支付
      checkPatType(type) {
        this.pay = type;
        // 如果是微信则请求支付二维码
        if(type === 2) {
          // 微信支付 生成支付二维码
          this.makeWechatpayLoading = true;
          EventBus.$emit('globalLoadingFun', {bool:true,loading:true});
          resultcommons.apiWechatpay(this,{no:this.info.no}).then(app=>{
            if(app.state === 200){
              this.base64 = app.data.base64;
              this.makeWechatpayLoading = false;
              // 创建定时任务
              if(!Window.timerUploadOrder){
                Window.timerUploadOrder = setInterval(() => {
                  this.timerUploadOrder();
                }, 1000);
              }
            }else{
              this.$message.showMsgBox({
                type: 'warning',
                content: app.message
              });
            }
            EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
          });
          // 计算满减优惠
        }else{
          // clearInterval(Window.timerUploadOrder);
        }
      },
      // 支付宝支付
      payZhifubaoFun() {
        // 加载中
        this.isJumpSuccess = true;
        // 创建定时任务
        if(!Window.timerUploadOrder){
          Window.timerUploadOrder = setInterval(() => {
            this.timerUploadOrder();
          }, 1000);
        }
        // 执行跳转
        window.open(this.paymentBaseUrl + '/alipay/pagepay.html?no=' + this.info.no, '_blank');
      }
    },
    created() {
      this.isLoading = true;
      this.id = this.parameter.token;
      EventBus.$emit('globalLoadingFun', {bool:true,loading:true});
      // 标签
      resultcommons.apiOrdercataloginfo(this,{token:this.id}).then(app=>{
        if(app.state === 200){
          console.log(app.data);
          this.info = app.data;
        }else{
          this.$message.showMsgBox({
            type: 'warning',
            content: app.message
          });
        }
        this.isLoading = false;
        EventBus.$emit('globalLoadingFun', {false:true,loading:false});
        // 轮询订单状态
        Window.timerUploadOrder = setInterval(() => {
          this.timerUploadOrder();
        }, 1000);
      });
    },
    mounted() {
    },
    destroyed() {
      clearInterval(Window.timerUploadOrder);
    }
  }
</script>

<style scoped lang='less'>

  .orderContent {
    padding: 20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    background: #F5F5F7;
    color: #000000;
    width: 60vw;
    height: 100%;
    padding-bottom: 0;
    overflow-y: auto;
    .zhifuBox{
      border-radius: 5px;
      background: #FFFFFF;
      padding: 20px;
      div.zhifubaoBox{
        background: #CCE5FF;
        border: 1px solid #B8DAFF;
        border-radius: 5px;
        padding: 15px;
        h2{
          margin-left: -7px;
        }
      }
      div.weixinBox{
        background: #CCE5FF;
        border: 1px solid #B8DAFF;
        border-radius: 5px;
        padding: 15px;
        display: flex;
        div.leftBox{
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          h2{
            margin-left: -7px;
          }
        }
        div.rightBox{
          flex: 1;
          text-align: right;
          img{
            width: 100px;
          }
        }
      }
      div.fangshiBox{
        span{
          position: relative;
          margin-right: 5px;
          border-bottom: 0;
          padding: 8px 15px;
          display: inline-block;
          border-radius: 5px;
          color: #000000;
          background: #F5F5F7;
          border: 1px solid #E5E5E5;
          &.active{
            background: #CCE5FF;
            border: 1px solid #B8DAFF;
            i{
              display: block;
            }
          }
          &:hover{
            border: 1px solid #B8DAFF;
          }
          img{
            height: 18px;
            margin-top: -2px;
          }
          &:last-child{
            margin: 0;
          }
          i{
            display: none;
            color: #28A745;
            position: absolute;
            right: -3px;
            bottom: -4px;
          }
        }
      }
      div.paySuccessBox{
        text-align: center;
        padding: 50px 0;
        background: #F5F5F7;
        border-radius: 5px;
        i{
          font-size: 56px;
        }
        div{
          margin-top: 15px;
          font-weight: bold;
        }
      }
    }
    table{
      margin: 0;
      tr{
        td,th{
          white-space: nowrap;
        }
      }
    }
    .titleBox {
      color: #000000;
      margin-bottom: 30px;
      p {
        margin: 0;
        //color: rgba(255, 255, 255, 0.5);
      }
      h2{
        font-size: 22px;
      }
    }
    div.jiazaiBox{
      margin-bottom: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 5px;
      /*box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);*/
      background: #FFFFFF;
      min-height: 100vh;
      .spinner-border{
        width: 3rem;
        height: 3rem;
      }
    }
    div.searchBox{
      display: flex;
      border-radius: 5px;
      padding: 20px;
      background: #FFFFFF;
      div.box{
        flex: 1;
        width: 100%;
        height: 100%;
        border-radius: 5px;
        div.goodsBox{
          span{
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            background: #F5F5F7;
            line-height: 3em;
            padding: 0 15px;
            border-radius: 5px;
            //border: 1px solid rgba(255,255,255,0.1);
            position: relative;
            margin-bottom: 10px;
            i{
              font-style: normal;
            }
          }
        }
      }
    }
    div.threeBox{
      padding: 20px;
      background: #FFFFFF;
      div.emptyBox{
        line-height: 4em;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #F5F5F7;
        border-radius: 5px;
      }
      table{
        tr{
          td,th{

          }
        }
      }
      dl{
        margin: 0;
        dt{
          padding-left: 0;
        }
        dd{
          margin-bottom: 0;
          p{
            margin-bottom: 0.5rem;
            &:last-child{
              padding-bottom: 10px;
              border-bottom: 1px solid #E5E5E5;
              font-size: 13px;
              i{
                font-size: 0.9rem;
              }
            }
            &:first-child{
            }
            span.copy{
              cursor: pointer;
              &:hover{
                color: #28A745;
              }
              &:active{
                color: #212529;
              }
            }
          }
        }
        &:last-child{
          dd{
            margin: 0;
            p:last-child{
              border: 0;
              margin: 0;
              padding: 0;
            }
          }
        }
      }
    }
  }

  @media (max-width: 1200px) {
    .orderContent{
      width: 70vw;
    }
  }

  @media (max-width: 992px) {
    .orderContent{
      width: 90vw;
    }
  }

  @media (max-width: 776px) {
    .orderContent{
      width: 90vw;
      padding: 10px;
      div.searchBox{
        padding: 20px;
      }
      div.threeBox{
        padding: 20px;
      }
    }
  }

  @media (max-width: 575px) {
    .abilityContent{
      div.threeBox{
        dl{
          dt{
            padding: 0;
            color: #000000;
            font-size: 16px;
            margin-bottom: 10px;
          }
          dd{
            margin: 0;
            padding: 0;
            margin-bottom: 15px;
            p{
              margin-bottom: 5px;
              &:nth-child(1){
                font-weight: bold;
              }
              &:last-child{
                margin: 0;
                padding-bottom: 15px;
              }
            }
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/common/order/Ordercatalog.vue